/**
 * Utilidad para obtener la hora actual en la zona horaria de la radio
 * La radio está en Barcelona, España (Europe/Madrid)
 */

const RADIO_TIMEZONE = 'Europe/Madrid';

/**
 * Obtiene la hora actual en la zona horaria de la radio como decimal
 *
 * @returns {number} - Hora actual en formato decimal (ej: 14.5 = 14:30)
 */
export function getRadioCurrentTime() {
  try {
    const now = new Date();

    // Formatear la fecha en la zona horaria de la radio
    const radioTimeString = now.toLocaleString('en-US', {
      timeZone: RADIO_TIMEZONE,
      hour: '2-digit',
      minute: '2-digit',
      hour12: false
    });

    // Extraer horas y minutos (formato: "14:30")
    const [hours, minutes] = radioTimeString.split(':').map(Number);

    // Convertir a formato decimal
    return hours + minutes / 60;
  } catch (error) {
    console.error('Error obteniendo hora de la radio:', error);
    // Fallback: usar hora local del navegador
    const now = new Date();
    return now.getHours() + now.getMinutes() / 60;
  }
}

/**
 * El día de la semana en la zona de la radio, en el mismo español que usa
 * `programas.json` («Lunes» … «Domingo»).
 *
 * Va aquí y no en el servicio porque es la misma pregunta que `getRadioCurrentTime`:
 * qué hora —y qué día— es EN LA RADIO. Usar el día del navegador rompería a
 * quien mire desde otra zona horaria justo en el cambio de día, que es cuando
 * la parrilla cambia de programa.
 *
 * @returns {string} p. ej. «Martes»
 */
export function getRadioCurrentDay() {
  const DIAS = ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'];
  try {
    const enLaRadio = new Date(
      new Date().toLocaleString('en-US', { timeZone: RADIO_TIMEZONE })
    );
    return DIAS[enLaRadio.getDay()];
  } catch (error) {
    return DIAS[new Date().getDay()];
  }
}
